import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import './style.css'
import i18n from './i18n'

console.log("importing components");
// Import components
import UploadPage from './components/UploadPage.vue'
import DownloadPage from './components/DownloadPage.vue'
import AdminDashboard from './components/AdminDashboard.vue'
import ConfirmPage from './components/ConfirmPage.vue'
import AboutPage from './components/AboutPage.vue'
import ContactPage from './components/ContactPage.vue'
import LoginPage from './components/LoginPage.vue'
import RegisterPage from './components/RegisterPage.vue'
import AuthCallbackPage from './components/AuthCallbackPage.vue'

console.log("creating router");
// Create router
const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', component: UploadPage },
    { path: '/about', component: AboutPage },
    { path: '/contact', component: ContactPage },
    { path: '/login', component: LoginPage },
    { path: '/register', component: RegisterPage },
    { path: '/auth-callback', component: AuthCallbackPage },
    { path: '/confirm', component: ConfirmPage },
    { path: '/download/:id', component: DownloadPage },
    { 
      path: '/admin/dashboard', 
      component: AdminDashboard,
      meta: { requiresAdmin: true }
    }
  ]
})

// Navigation guard for admin routes
router.beforeEach((to, from, next) => {
  console.log("to", to);
  if (to.meta.requiresAdmin) {
    const userStr = localStorage.getItem('user')
    if (!userStr) {
      next('/login')
      return
    }
    
    try {
      const user = JSON.parse(userStr)
      if (user.role !== 'admin') {
        next('/')
        return
      }
    } catch (error) {
      console.error('Error parsing user data:', error)
      localStorage.removeItem('user')
      next('/login')
      return
    }
  }
  next()
})

// Create app
const app = createApp(App)
console.log("router", router);
app.use(router)
console.log("app", app);
app.use(i18n)
console.log("app", app);
app.mount('#app') 
console.log("app", app);